import styled from 'styled-components';
import { NodeButton } from 'common/components/TouchpointEditor/components/TouchpointSidebar/ElementsListMenu';

export const HeaderWithLayoutContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
`;

export const VirtualContentWithLayoutContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
`;

export const AddEmbedButton = styled(NodeButton)`
    & .SuiButton-label {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;
